import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
// ข้อมูล translations สำหรับแต่ละภาษา
i18n
  .use(Backend)
  // ตรวจจับภาษาของผู้ใช้ (เช่น จากเบราว์เซอร์)
  .use(LanguageDetector)
  // ส่ง i18n instance ไปยัง react-i18next
  .use(initReactI18next)
  // กำหนดค่าเริ่มต้น
  .init({
    // resources,
    backend: {
      loadPath: './locales/{{lng}}/{{ns}}.json',
    },
    fallbackLng: "th", // ภาษาเริ่มต้นหากไม่พบภาษาที่ตรวจจับได้
    debug: false, // เปิด debug log ใน console (ปิดใน production)
    interpolation: {
      escapeValue: false, // ไม่อนุญาตให้ escape ค่า HTML (React ป้องกัน XSS อยู่แล้ว)
    },
    detection: {
      order: ["querystring", "cookie", "localStorage", "localStorage"], 
    },
  });

export default i18n;
